import { RadioButton } from '../../RadioButton/__internal__';
import { jsx as _jsx } from "react/jsx-runtime";
export const SelectionRadioButton = props => {
  const {
    getRowIdentifier,
    getRowIndex,
    rowCount,
    localize,
    singleSelectionOverrides,
    hideSelectAll,
    areRowsVisible,
    setSelectRow,
    isRowDisabled,
    isRowReadOnly,
    readOnly
  } = props.itemData;
  const rowKey = props.rowIndex !== -1 ? getRowIdentifier(props.rowIndex) : undefined;
  const disabled = rowKey ? !!isRowDisabled?.(rowKey) : false;
  const readOnlyRow = readOnly || rowKey && !!isRowReadOnly?.(rowKey);
  const selectedRows = props.itemData.preference?.selectedRows;
  const getAriaLabel = () => {
    if (props.ariaLabel) {
      return props.ariaLabel;
    } else if (props.ariaLabelledBy) {
      return undefined;
    } else {
      return localize('rowSelectionRadioButtonAriaLabel.msg', {
        rowIndex: `${props.rowIndex + 1}`
      });
    }
  };
  return /*#__PURE__*/_jsx("div", {
    style: props.style,
    onMouseDown: e => {
      e.preventDefault();
    },
    onClick: () => {
      if (disabled || readOnlyRow) return;
      props.itemData?.setInteractiveAction?.(true);
      setSelectRow?.({
        index: props.rowIndex,
        selected: singleSelectionOverrides?.allowDeselection && selectedRows?.has(getRowIdentifier(props.rowIndex)) ? false : true,
        selectionType: 'radioButton',
        clearPrevious: true,
        rowCount,
        rangeSelection: false,
        rowKey: getRowIdentifier,
        getRowIndex,
        hideSelectAll,
        areRowsVisible,
        isRowDisabled,
        isRowReadOnly
      });
    },
    children: /*#__PURE__*/_jsx(RadioButton, {
      selected: props.selected,
      testId: `row-${props.rowIndex}`,
      focusable: false,
      ariaLabelledBy: props.ariaLabelledBy,
      ariaLabel: getAriaLabel(),
      disabled: disabled,
      readOnly: !!readOnlyRow
    })
  });
};
//# sourceMappingURL=SelectionRadioButton.js.map